module.exports = __webpack_public_path__ + "static/card-one-bd100c4bc24e0bd0b27d4c68a8f408c3.jpg";